import { createTheme } from 'flowbite-react';

export const tabsTheme = createTheme({
  tabs: {
    base: 'flex flex-col',
    tablist: {
      base: "flex items-center pb-4 mx-4 before:content-['Показывать_операции:'] before:text-gray-500 before:font-semibold before:mr-4",
      tabitem: {
        base: 'flex items-center justify-center px-4 py-2 p-0 border border-gray-200 first:rounded-l-md last:rounded-r-md text-sm font-normal focus:outline-none disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500',
        variant: {
          default: {
            base: 'px-4 py-2',
            active: {
              on: 'border-brand-purple-900 text-brand-purple-900 bg-transparent rounded-none',
              off: 'text-gray-900 hover:bg-gray-100 hover:text-gray-700 rounded-none',
            },
          },
        },
        icon: 'mr-2 h-5 w-5',
      },
    },
    tabpanel: 'pb-0',
  },
}).tabs;
